module.exports = __webpack_public_path__ + "static/media/asm2.81bad81f.jpg";